/**
 * Wallet Slice
 * Flutter source: lib/domain/notifiers/wallet_notifier.dart
 *
 * App-level Redux state for the user's wallet.
 * Provides synchronous access to wallet balance across the app.
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { WalletState } from '@/domain/entities/wallet/walletState';
import type { WalletEntity } from '@/domain/entities/wallet/walletEntity';
import type { RootState } from '@/presentation/store';

const initialState: WalletState = {
  wallet: null,
  isLoaded: false,
};

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setWallet: (state, action: PayloadAction<WalletEntity | null>) => {
      state.wallet = action.payload;
      state.isLoaded = true;
    },
    clearWallet: (state) => {
      state.wallet = null;
      state.isLoaded = false;
    },
  },
});

export const { setWallet, clearWallet } = walletSlice.actions;
export default walletSlice.reducer;

// --- Selectors ---

export const selectWallet = (state: RootState): WalletEntity | null =>
  state.wallet.wallet;

export const selectWalletLoaded = (state: RootState): boolean =>
  state.wallet.isLoaded;

export const selectWalletCoins = (state: RootState): number =>
  state.wallet.wallet?.coins ?? 0;

export const selectWalletDiamonds = (state: RootState): number =>
  state.wallet.wallet?.diamonds ?? 0;
